import { useEffect, useState } from "react";
import { FormControl,  Modal, Button, Alert,  Col, Form, Row, Container,  } from 'react-bootstrap';
import { GetHeadersOpts } from '../../App';
import Confirm from '../../common/widgets/Confirm'
import ValResult from "../../common/widgets/ValResult"
import DatePicker from "react-datepicker";
import './FinderFileEditor.css'
import "react-datepicker/dist/react-datepicker.css";
import ZipCodeLookup from "../../common/zipCode/ZipCodeLookup";
import { AlertType } from "../../common/zipCode/AlertType";
import { ZipCodeLookupResult } from "../../common/zipCode/ZipCodeLookupResult";

interface FinderFileEditorProps {
    getHeaders: (opts?: GetHeadersOpts) => Headers
    onFinderFileSave: () => void
    finderFile: any
}


const FinderFileEditor = (props: FinderFileEditorProps) => {


    const { finderFile } = props;
    const [delmode, setDelmode] = useState(finderFile.id === "0" ? "disabled" : ""); // possible values: disabled, blank, prompt, confirmed
    const [customOptions, setCustomOptions] = useState({ customOptionsList: [], isDataLoaded: false });
    const [fileRunDate, setfileRunDate] = useState(new Date()); // this is for DatePicker
    const [alertx, setAlertx] = useState<any>({ message: "", variant: "", setShow: true })


    useEffect(() => {
        // initialize 
        if (customOptions.customOptionsList.length === 0 && customOptions.isDataLoaded === false) {
            // register function for saving this component 
            loadcustomOptionsData();
        }
    }, [customOptions]);


    const loadcustomOptionsData = async () => {

        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/Campaign`;
        //console.log("Preparing to call api:" + _url);

        fetch(_url, {
            headers: props.getHeaders(),
            method: "GET"
        })
            .then(response => response.json())
            .then((resp: any) => {

                setCustomOptions({ customOptionsList: resp.data, isDataLoaded: true });

            });

    }


    const [frm, setFrm] = useState({
        batchId: finderFile.batchId,
        firstName: finderFile.firstName,
        lastName: finderFile.lastName,
        fullName: finderFile.fullName,
        addressOne: finderFile.addressOne,
        addressTwo: finderFile.addressTwo,
        city: finderFile.city,
        state: finderFile.state,
        zipcode: finderFile.zipcode,
        keyCode: finderFile.keyCode,
        finderNumber: finderFile.finderNumber,
        customerNumber: finderFile.customerNumber,
        fileName: finderFile.fileName,
        fileLineNumber: finderFile.fileLineNumber,
        campaignID: finderFile.campaignID,
        fileRunDate: finderFile.fileRunDate
        //createDate: finderFile.createDate,
    });

    // server side validation errors
    const [errors, setErrors] = useState({
        batchId: "",
        firstName: "",
        lastName: "",
        fullName: "",
        addressOne: "",
        addressTwo: "",
        city: "",
        state: "",
        zipcode: "",
        keyCode: "",
        finderNumber: "",
        customerNumber: "",
        fileName: "",
        fileLineNumber: "",
        campaignID: "",
        fileRunDate: "",
        //createDate: ""
    })

    const close = () => {
        props.onFinderFileSave();
    }

    const onDeleteConfirm = (resp: boolean) => {
        if (resp) {
            save(); // initiate save to delete
        }
        else {
            setDelmode("") // clear confirm popup.
        }
    }

    const save = () => {
        if (!validateForm()) {
            return;
        }

        // save some stuff
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/FinderFiles`;
        var _method = "";
        var _data: any;
 
        // FinderFile record
        // batchid should be same as dto in this case... so just copy
        var data = {
            ...frm,
            id: finderFile.id,
            batchId: finderFile.batchID,
            fileRunDate: new Date().toDateString()
        }
        const httpMethod = finderFile.id === "0" ? "POST" : delmode === "prompt" ? "DELETE" : "PUT";

        if (httpMethod === "POST" || httpMethod === "PUT") {
            _method = httpMethod;
            _data = JSON.stringify(data);
        }

        if (httpMethod === "DELETE") {
             _method = "DELETE";
            _url += "/" + finderFile.id;
            _data = {}
        }

        fetch(_url, {
            headers: props.getHeaders(),
            method: _method,
            body: _data
            })
            .then(response => response.json())
            .then((resp: any) => {
                if (resp.success) {
                    props.onFinderFileSave();
                }
                else {
                    // validation errors? 
                    if (resp.hasOwnProperty("errors")) {
                        var err = resp.errors;
                        var newErrors = { ...errors };
                        newErrors.batchId = err.BatchId ? err.BatchId[0] : ""
                        newErrors.firstName = err.FirstName ? err.FirstName[0] : ""
                        newErrors.lastName = err.LastName ? err.LastName[0] : ""
                        newErrors.fullName = err.FullName ? err.FullName[0] : ""
                        newErrors.addressOne = err.AddressOne ? err.AddressOne[0] : ""
                        newErrors.addressTwo = err.AddressTwo ? err.AddressTwo[0] : ""
                        newErrors.city = err.City ? err.City[0] : ""
                        newErrors.state = err.State ? err.State[0] : ""
                        newErrors.zipcode = err.Zipcode ? err.Zipcode[0] : ""
                        newErrors.keyCode = err.KeyCode ? err.KeyCode[0] : ""
                        newErrors.finderNumber = err.FinderNumber ? err.FinderNumber[0] : ""
                        newErrors.customerNumber = err.CustomerNumber ? err.CustomerNumber[0] : ""
                        newErrors.fileName = err.FileName ? err.FileName[0] : ""
                        newErrors.fileLineNumber = err.FileLineNumber ? err.FileLineNumber[0] : ""
                        newErrors.campaignID = err.CampaignID ? err.CampaignID[0] : ""
                        setErrors(newErrors);
                    } else {
                        setAlertx({ message: resp.status, variant: "danger" });
                    }

                }
                // 
            });

    }


    const onFormChange = (name: string, e: any) => {
        var newFrm: any = { ...frm };
        newFrm[name] = e.target.value;
        setFrm(newFrm);
    }

    const onFileRunDateChange = (runDate: Date) => {
        setfileRunDate(runDate);
        setFrm({ ...frm, ["fileRunDate"]: runDate });
    }

    const onZipCodeSelection = (result: ZipCodeLookupResult) => {
        // city,county,state,country
        setFrm({ ...frm, ["city"]: result.city, ["state"]: result.state });
    }   

    const onZipCodeLookupError = (e: AlertType) => {
        setAlertx({ message: e.message, variant: e.variant, setShow: true });
    }
    const validateForm = () => {

        let formIsValid = true;
        var newErrors = { ...errors };

        if (!frm.firstName) {
            formIsValid = false;
            newErrors.firstName = "First name is required.";
        }

        if (!frm.lastName) {
            formIsValid = false;
            newErrors.lastName = "Last name is required.";
        }

        if (!frm.addressOne) {
            formIsValid = false;
            newErrors.addressOne = "Address one is required.";
        }

        if (!frm.city) {
            formIsValid = false;
            newErrors.city = "City is required.";
        }

        if (!frm.state) {
            formIsValid = false;
            newErrors.state = "State is required.";
        }

        if (!frm.zipcode) {
            formIsValid = false;
            newErrors.zipcode = "Zip code is required.";
        }

        if (!frm.campaignID) {
            formIsValid = false;
            newErrors.campaignID = "Campaign is required.";
        }

        if (!frm.keyCode) {
            formIsValid = false;
            newErrors.keyCode = "KeyCode is required.";
        }

        if (!frm.finderNumber) {
            formIsValid = false;
            newErrors.finderNumber = "Finder Number is required.";
        }

        if (!frm.fileName) {
            formIsValid = false;
            newErrors.fileName = "File Name is required.";
        }

        if (!frm.fileLineNumber) {
            formIsValid = false;
            newErrors.fileLineNumber = "File line number is required.";
        }

        if (!frm.fileRunDate) {
            formIsValid = false;
            newErrors.fileRunDate = "File run date is required.";
        }
        setErrors(newErrors);
        return formIsValid;
    }


    return (<Modal show={true} onHide={close} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Finder File</Modal.Title>
        </Modal.Header>
        <Modal.Body>

            <Container>
                <Row>

                    {alertx.message ? <div><Alert variant={alertx.variant} show={alertx.setShow} onClose={() => setAlertx({ setShow: false })} dismissible >{alertx.message}</Alert></div> : null}
                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                        
                      
                    </Form.Group>

                    <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                            First Name
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl
                                placeholder="First Name"
                                aria-label="firstName"
                                aria-describedby="basic-addon1"
                                value={frm.firstName}
                                onChange={(e) => onFormChange("firstName", e)}
                            />
                            <ValResult error={errors.firstName} />
                        </Col>
                        <Form.Label column sm={2}>
                            Last Name
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl
                                placeholder="Last Name"
                                aria-label="lastName"
                                aria-describedby="basic-addon1"
                                value={frm.lastName}
                                onChange={(e) => onFormChange("lastName", e)}
                            />
                            <ValResult error={errors.lastName} />
                        </Col>
                    </Form.Group>



                    <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                            Address One
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl  
                                placeholder="Address One"
                                aria-label="addressOne"
                                aria-describedby="basic-addon1"
                                value={frm.addressOne}
                                onChange={(e) => onFormChange("addressOne", e)}
                            />  <ValResult error={errors.addressOne} />
                        </Col>
                        <Form.Label column sm={2}>
                            Address Two
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl 
                                placeholder="Address Two"
                                aria-label="addressTwo"
                                aria-describedby="basic-addon1"
                                value={frm.addressTwo}
                                onChange={(e) => onFormChange("addressTwo", e)}
                            />
                            <ValResult error={errors.addressTwo} />
                        </Col>

                    </Form.Group>



                    <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                            City
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl
                                placeholder="City"
                                aria-label="city"
                                aria-describedby="basic-addon1"
                                value={frm.city}
                                onChange={(e) => onFormChange("city", e)}
                            />
                            <ValResult error={errors.city} />
                        </Col>
                        <Form.Label column sm={2}>
                            State
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl
                                placeholder="State"
                                aria-label="state"
                                aria-describedby="basic-addon1"
                                value={frm.state}
                                onChange={(e) => onFormChange("state", e)}
                            />  <ValResult error={errors.state} />
                        </Col>
                    </Form.Group>



                    <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                            Zip code
                        </Form.Label>
                        <Col sm={4}>
                            

                            <ZipCodeLookup
                                key={"zip"}
                                placeholder="Zip code"
                                txtValue={frm.zipcode}
                                onZipChangeFunction={(e: any) => {
                                    return onFormChange("zipcode", e);
                                }}
                                lookupResultHandler={(e: ZipCodeLookupResult) => {
                                    onZipCodeSelection(e);
                                }}
                                secureHeaders={props.getHeaders()}
                                errorMessageHandler={onZipCodeLookupError}
                            />

                            <ValResult error={errors.zipcode} />
                        </Col>
                        <Form.Label column sm={2}>
                            Campaign
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Select aria-label="Select Campaign" value={frm.campaignID} onChange={(e) => onFormChange("campaignID", e)} >
                                <option>Select Campaign</option>
                                {customOptions.customOptionsList.map(item => (
                                    <option
                                        key={item['campaignID']}
                                        value={item['campaignID']}
                                    >
                                        {item['campaignName']}
                                    </option>
                                ))}
                            </Form.Select>
                            <ValResult error={errors.campaignID} />
                        </Col>
                    </Form.Group>


                    <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">

                        <Form.Label column sm={2}>
                            Customer #
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl
                                placeholder="Customer Number"
                                aria-label="customerNumber"
                                aria-describedby="basic-addon1"
                                value={frm.customerNumber}
                                onChange={(e) => onFormChange("customerNumber", e)}
                            />
                            <ValResult error={errors.customerNumber} />
                        </Col>

                        <Form.Label column sm={2}>
                            Key Code
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl
                                placeholder="KeyCode"
                                aria-label="keyCode"
                                aria-describedby="basic-addon1"
                                value={frm.keyCode}
                                onChange={(e) => onFormChange("keyCode", e)}
                            />                    <ValResult error={errors.keyCode} />

                        </Col>


                    </Form.Group>


                    <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                            Finder #
                        </Form.Label>
                        <Col sm={4}>
                            <FormControl
                                placeholder="Finder Number"
                                aria-label="finderNumber"
                                aria-describedby="basic-addon1"
                                value={frm.finderNumber}
                                onChange={(e) => onFormChange("finderNumber", e)}
                            />                            <ValResult error={errors.finderNumber} />

                        </Col>


                        <Form.Label column sm={2}>
                            File Name
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Control placeholder="File Name" value={frm.fileName} required
                                onChange={(e: any) => onFormChange("fileName", e)} />
                            <ValResult error={errors.fileName} />
                        </Col>
                       
                    </Form.Group>

                   

                  

            


                    <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                        <Form.Label column sm={2}>
                            File Line #
                        </Form.Label>
                        <Col sm={4}>
                            <Form.Control placeholder="File Line Number" value={frm.fileLineNumber} required
                                onChange={(e: any) => onFormChange("fileLineNumber", e)} />
                            <ValResult error={errors.fileLineNumber} />

                        </Col>
                      

                        <Form.Label column sm={2}>
                            File Run Date
                        </Form.Label>
                        <Col sm={4}>
                            <DatePicker selected={fileRunDate} className="form-control" required dateFormat="MM/dd/yyyy" showYearDropdown={true} scrollableYearDropdown={true}
                                onChange={(date: Date) => onFileRunDateChange(date)}
                            />

                            <ValResult error={errors.fileRunDate} />

                        </Col>
                      
                    </Form.Group>

                  


                    {/* Show Delete confirm if called */}
                    {delmode !== "prompt" ? null :
                        <Confirm onResponse={onDeleteConfirm}
                            headerText="Delete" onClose={() => setDelmode("")}
                            bodyText="Are you sure you want to delete this finder file?"
                        />
                    }

                </Row>
            </Container>


        </Modal.Body>
        <Modal.Footer>
            <div className="w-100" >
                <Button onClick={save} variant="primary" className="ms-1" >
                    <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/disk_blue.png")`, "marginRight": "5px" }} ></i>
Save</Button>
                <Button variant="secondary" className="ms-1" onClick={close}>
                    <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/undo.png")`, "marginRight": "5px" }} ></i>

                    Cancel</Button>
                {delmode !== "disabled" ? <Button variant="danger" className="float-end" onClick={() => setDelmode("prompt")} >              <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/delete.png")`, "marginRight": "5px" }} ></i>
Delete</Button> : null}
            </div>

        </Modal.Footer>
    </Modal>)

}

export default FinderFileEditor;